"use strict";
module.exports = ['$translate', '$http', '$httpParamSerializer', 'ngDroUAACommon', function ($translate, $http, $httpParamSerializer, ngDroUAACommon) {

        this.findOne = function (id, usePrefix) {                              // DA TESTARE
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/group/' + id)
            });
        };

        this.findAll = function (usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/group')
            });
        };

        this.delete = function (id, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'DELETE',
                url: ngDroUAACommon.getUrl('api/group/' + id),
                withCredentials: true,
            });
        };

        this.save = function (params, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'POST',
                url: ngDroUAACommon.getUrl('api/group'),
                withCredentials: true,
                data: params
            });
        };

        this.update = function (params, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'PUT',
                url: ngDroUAACommon.getUrl('api/group'),
                withCredentials: true,
                data: params
            });
        };

        return {
            findAll: this.findAll,
            findOne: this.findOne,
            update: this.update,
            delete: this.delete,
            save: this.save
        };
    }];




//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/services/rest/group.js
// module id = 397
// module chunks = 0